<template>
<v-container class="text-center px-5">
  <v-row>
    <v-col>
      <v-btn-toggle v-model="type" mandatory>
        <v-btn small value="any">Any</v-btn>
        <v-btn small value="director">Director</v-btn>
        <v-btn small value="writer">Writer</v-btn>
        <v-btn small value="actor">Actor</v-btn>
      </v-btn-toggle>
    </v-col>
  </v-row>
  <v-row class="px-5">
    <person-field v-model="value" />
  </v-row>
</v-container>
</template>

<script>
import PersonField from "@/components/search/fields/PersonField"

export default {
  name: "PersonFilterBuilder",
  components: {
    PersonField,
  },
  data() {
    return {
      type: "any",
      value: "",
    }
  },
  methods: {
    init() {
      this.type = "any"
      this.value = ""
    },

    build(negate) {
      if (!this.value) return [null, "You need to select a person"]
      const prefix = negate ? "not " : ""
      const op = negate ? "and" : "or"
      switch (this.type) {
        case "any":
          return [`${prefix}directed by ${this.value} ` +
                  `${op} ${prefix}written by ${this.value} ` +
                  `${op} ${prefix}starring ${this.value}`]
        case "director":
          return [`${prefix}directed by ${this.value}`]
        case "writer":
          return [`${prefix}written by ${this.value}`]
        case "actor":
          return [`${prefix}starring ${this.value}`]
      }
      return ""
    },
  }
}
</script>
